<template>
  <div class="ckeditor">
    <textarea :id="id" :value="value">
    </textarea>
  </div>
</template>
<script>
export default {

  name: "ck-editor",

  props: {
    dir: String,
    value: {
      type: String
    },
    id: {
      type: String,
      default: 'editor'
    },
    height: {
      type: String,
      default: '120px',
    },
    toolbarGroups: {
      type: Array,
      default: () => [
        { name: 'basicstyles' },
        { name: 'paragraph', groups: [ 'list', 'align', 'bidi' ] },
        { name: 'others', groups: [ 'cleanup' ] },
        { name: 'editing', groups: [ 'spellchecker'] },
				{ name: 'insert', groups: [ 'insert' ] },
        { name: 'others2', groups: [ 'mode' ] },
      ]
    },
    toolbar: {
      type: Array,
      default: () => [
        // ['Undo','Redo'],
        // ['Bold','Italic','Strike'],
        // ['Link'],
        // ['Table'],
        // ['Source']
      ]
    },
    language: {
      type: String,
      default: 'en'
    },
    extraplugins: {
      type: String,
      default: ''
    }
  },

  beforeUpdate () {
    const ckeditorId = this.id
    if (this.value !== CKEDITOR.instances[ckeditorId].getData()) {
      CKEDITOR.instances[ckeditorId].setData(this.value)
    }
  },

  mounted () {
    const ckeditorId = this.id
    const ckeditorConfig = {
      disableNativeSpellChecker: false,
      toolbarGroups: this.toolbarGroups,
      language: this.language,
      height: this.height,
      extraPlugins: this.extraplugins,
      contentsLangDirection: this.dir,
      removeButtons: 'HorizontalRule,Table,Flash,Image,SpecialChar,PageBreak,Iframe',
      removePlugins: 'elementspath',
      resize_enabled: true,
    }
    CKEDITOR.replace(ckeditorId, ckeditorConfig)
    CKEDITOR.instances[ckeditorId].setData(this.value)
    CKEDITOR.instances[ckeditorId].on('change', () => {
      let ckeditorData = CKEDITOR.instances[ckeditorId].getData()
      if (ckeditorData !== this.value) {
        this.$emit('input', ckeditorData)
      }
    })
  },

  destroyed () {
    const ckeditorId = this.id
    if (CKEDITOR.instances[ckeditorId]) {
      CKEDITOR.instances[ckeditorId].destroy()
    }
  }
}
</script>
<style lang="scss">

.ckeditor {

  #cke_editor {
    background-color: #edf2f7;
    border-radius: 4px;
    overflow: hidden;

    .cke_bottom, .cke_top {
      background-color: #edf2f7;
    }

    &.cke_focus {
      border-color: #80bdff;
    }
  }
}
</style>
